import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon from '../../components/Icon/Icon';

const NotFoundPage = () => (
  <div className="not-found-page">
    <h1 className="not-found-page-title">404</h1>
    <p className="not-found-page-description">
      <FormattedMessage id="not_found_page.not-found" defaultMessage="Not found" />
    </p>
    <Link to="/" className="btn btn-primary btn-md">
      <Icon type="chevron-right" />
      <FormattedMessage id="not_found_page.back" defaultMessage="Back to homepage" />
    </Link>
  </div>
);

export default NotFoundPage;
